import { Module } from 'vuex'
import {
  getters,
  initState,
  UserFunctions,
} from '@/store/settings/roles/state'
import { State as RootState } from '@/store/state'
import { mutations } from '@/store/settings/roles/mutations'
import { actions } from '@/store/settings/roles/actions'

const module: Module<UserFunctions, RootState> = {
  namespaced: true,
  state: initState,
  mutations,
  actions,
  getters,
}

export default module
